<template>
  <div>
    <van-tabbar v-model="active" active-color="#0057FF" inactive-color="#9CA3AF" style="z-index: 10;" @change="onChange">
      <template v-for="(item,index) in menu">
        <van-tabbar-item v-if="item.visit && item.key!=='car'" :key="index" :to="item.url">
          <span>{{ item.name }}</span><br>
          <van-icon slot="icon" :name="item.icon" />
        </van-tabbar-item>
        <van-tabbar-item v-if="item.visit && item.key==='car'" :key="index" :info="shoppingCarNum" :to="item.url">
          <span>{{ item.name }}</span><br>
          <van-icon slot="icon" :name="item.icon" />
        </van-tabbar-item>
      </template>
    </van-tabbar>
    <div v-if="showGiftAd" class="ActivityIcon" @click="onActivity">
      <div class="rect">
        <img src="/grouptest/xmas2019socks_icon.png">
        <div>
          <van-count-down v-if="!showGetGift" :time="timeActivity" :format="timeActivityFormat" style="color:#EDC788;font-size:0.8em;" @finish="onTimeActivityFinish" />
          <span v-if="showGetGift">查看奖品</span>
        </div>
      </div>
    </div>
    <van-overlay :show="showActivity" :z-index="101" @click="showActivity = false">
      <div class="wrapper">
        <div>
          <img src="/grouptest/xmas2019socks_ad.png">
          <van-button type="danger" size="large" :color="GetColorMain()" @click="onActivity">查看惊喜</van-button>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import commonData from '@/commondata.js'
import request from '@/utils/request'
import { CheckSystemType } from '@/utils/request'
import { Icon,Tabbar, TabbarItem, CountDown, Overlay, Button } from 'vant'
import { checkIsInAlipay, getUrlKey, getUserBase, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Icon.name]: Icon,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [CountDown.name]: CountDown,
    [Overlay.name]: Overlay,
    [Button.name]: Button
  },
  props: {
    value: undefined
  },
  data() {
    return {
      active: 0,
      shoppingCarNum: 0,
      system: undefined,
      timeActivity: 24 * 60 * 60 * 1000,
      timeActivityFormat: 'HH时mm分',
      showActivity: false,
      showGiftAd: false,
      activityId: 'xmas20192',
      showGetGift: false,
      menu: [
        // { visit: true, name: '首页', key: 'home', url: '/store/index', icon: 'iconfont iconshouye' },
        { visit: false, name: '潜水', key: 'dive', url: '/dive', icon: 'shop-o' },
        // { visit: true, name: '分类', key: 'type', url: '/store/storetype', icon: 'iconfont iconfenlei' },
        // { visit: true, name: '购物车', key: 'car', url: '/store/car', icon: 'iconfont icongouwuche' },
         { visit: true, name: '证书', key: 'cert', url: '/my/myCerificate', icon: 'description' },
        { visit: true, name: '我的', key: 'my', url: '/my/index', icon: 'manager-o' },
       
        { visit: false, name: '专业', key: 'pro', url: '/pro/index', icon: 'fire-o' }
      ]
    }
  },
  watch: {
    value(newValue) {
      this.active = this.getMenuValue(newValue)
      console.log('watch', newValue)
      console.log('watch active', this.active)
    }
  },

  created() {
    this.shoppingCarNum = commonData.shoppingCarNum
    this.active = this.getMenuValue(this.value)
    this.system = getUrlKey('system')
    if (this.system === 'haiwang') { // 海王特殊处理
      this.menu[0].name = '买装备'
      this.menu[1].name = '备忘录'
      this.menu[2].name = '玩潜水'
      this.menu[3].name = '购物车'
      this.menu[4].name = '我的'
      this.menu[5].name = '专业'
    }
    if (CheckSystemType('DiveBoss') && !checkIsInAlipay()) {
      this.menu.filter(el => el.key === 'dive')[0].visit = true
    } else {
      this.menu.filter(el => el.key === 'dive')[0].visit = false
    }
    getUserBase(data => {
      console.log('用户数据', data)
      if (data && data.proAccountId) {
        this.menu.filter(el => el.key === 'pro')[0].visit = true
      } else {
        this.menu.filter(el => el.key === 'pro')[0].visit = false
      }
    })
    this.getActivity(data => {
      if (!data.isEnable || !data.isShow) {
        return
      }
      this.showGiftAd = true
      var date1 = new Date(data.giftTime)
      this.timeActivity = date1 - new Date()
      if (this.timeActivity <= 60 * 60 * 1000) {
        this.timeActivityFormat = 'mm分ss秒'
      } else {
        this.timeActivityFormat = 'HH时mm分'
      }
      if (!commonData.activityData.isShowAd) {
        commonData.activityData.isShowAd = true
        this.showActivity = true
      }
    })
  },
  methods: {
    checkIsInAlipay,
    CheckSystemType,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    getMenuValue(key) {
      var j = -1
      for (var i = 0; i < this.menu.length; i++) {
        if (this.menu[i].visit) {
          j++
        }
        if (this.menu[i].key === key) {
          return j
        }
      }
      return 0
    },
    resetNum() {
      if (commonData.shoppingCarNum !== commonData.shoppingCarSaveNum) {
        this.onGetCarNum()
      } else {
        this.shoppingCarNum = commonData.shoppingCarNum
      }
      // console.log('resetNum', commonData.shoppingCarNum)
      // this.shoppingCarNum = commonData.shoppingCarNum
    },
    onChange(index) {
      this.$emit('input', index)
    },
    onTimeActivityFinish() {
      this.showGetGift = true
    },
    onGetCarNum() {
      request({
        url: '/StoreHelper/getShoppingCarNum',
        method: 'get'
      }).then(response => {
        if (!response.success) {
          return
        }
        commonData.shoppingCarNum = response.data
        commonData.shoppingCarSaveNum = response.data
        this.shoppingCarNum = response.data
      })
    },
    getActivity(callback) {
      if (commonData.activityData.isRead) {
        callback(commonData.activityData)
        return
      }
      request({
        url: '/StoreHelper/getGroupTimeGift',
        method: 'post',
        data: { key: this.activityId }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          commonData.activityData = response.data
          commonData.activityData.isRead = true
          callback(response.data)
        }
      })
    },
    onActivity() {
      if (commonData.activityData.isJoin) {
        this.$router.push('/group/giftBox/' + this.activityId)
      } else {
        this.$router.push('/group/group/' + this.activityId)
      }
    }
  }
}
</script>
<style scoped>
.ActivityIcon{
  position:fixed;
  right: 0;
  top: 60%;
  width: 5.5em;
  background-color:rgba(79, 97, 115, 0.8);
  font-size: 0.7em;
  text-align: center;
  color: #EDC788;
  padding: 0.2em 0.2em;
  border-top-left-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  z-index: 100;
}
.ActivityIcon .rect{
  border:1px solid #EDC788;
  border-radius: 0.4em;
}
.ActivityIcon .rect div{
  padding-bottom: 0.3em;
}
.ActivityIcon img{
  border-bottom: 1px solid #EDC788;
  width: 100%;
  margin-top: 0.3em;
  padding-bottom:0.3em;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper div{
  width: 70%;
}
.wrapper img{
  width: 100%;
}

</style>
